<template>
  <div v-if="len >= 1" class="rate">
    <p>{{title}}</p>
    <p>
      {{rates[0].rate}}
      <span v-if="len === 2">
        <span>/</span>
        {{rates[1].rate}}
      </span>
      <el-tooltip :disabled="variation === 0">
        <div slot="content">
          {{msg}}
        </div>
        <i :class="currentRate"/>
      </el-tooltip>
    </p>
  </div>
</template>

<script>

export default {
  props: {
    rates: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  name: 'rates',
  watch: {
  },
  computed: {
    title() {
      const base = 'procesa por minuto';
      return this.len === 2 ? `entra vs ${base}` : base;
    },
    len() {
      return this.rates.length;
    },
    currentRate() {
      const base = 'fas fa-snowplow';
      // eslint-disable-next-line no-nested-ternary
      return this.variation === 0 ? base : this.variation > 0 ? `${base} low` : `${base} high`;
    },
    variation() {
      return this.len === 2 ? this.rates[0].rate - this.rates[1].rate : 0;
    },
    msg() {
      const base = 'elementos de los que se procesan por minuto';
      return this.variation > 0 ? `entran más ${base}` : `entran menos ${base}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.rate {
  text-align: right;
  padding-right: 5px;
  p { color: $fb-grey-light-30; }
  p:first-child {
    margin: 4px 0 0;
    font-size: 12px;
    font-weight: 300;
  }
  p:last-child {
    font-size: 20px;
    font-weight: 900;
    margin: 0;
    span span {
      font-size: 18px;
      font-weight: 300;
    }
    i {
      font-size: 16px;
      margin-left: 3px;
      color: $fb-grey-light-80;
    }
    .low { color: $fb-red-light-20; }
    .high { color: $fb-blue-light-20; }
  }
}
</style>
